import MakeOffer from '../../src/legacy/MakeOffer.tsx';
export default MakeOffer;
